import { defineComponent as _defineComponent } from 'vue'
import { toRefs } from '@nuxtjs/composition-api';
import type { Props as IconProps } from '~/core/components/base/image/SvgThemedIcon.vue';

interface Props {
    icon?: IconProps,
    mainInfo?: string,
    secondaryInfo?: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'IconInfo',
  props: {
    icon: null,
    mainInfo: null,
    secondaryInfo: null
  },
  setup(__props: any) {

const props = __props as { icon?: IconProps, mainInfo?: string, secondaryInfo?: string };



const {
    icon,
    mainInfo,
    secondaryInfo,
} = toRefs(props);

return { __sfc: true,props, icon, mainInfo, secondaryInfo }
}

})